import React, { useState, useEffect } from "react";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../../providers/TranslationProvider";
import { Autocomplete, TextField  } from "@mui/material";
import "./feedbacksFilter.css";
import { getFeedbackStatusList } from "../../../features/manageFeedbacks/manageFeedbacksService";
// import "./../../manageFeedbacks.css";
interface FeedbacksFilterProps {
  dateFilter: Record<string, Dayjs>;
  typeAndStatusFilter: Record<string, string>;
  updateDate: (newDate: Dayjs, type: "to" | "from") => void;
  updateFeedbackType: (feedbackType: string) => void;
  updateFeedbackStatus: (feedbackStatus: string) => void;
  feedbackTypeList: string[];
}

const FeedbacksFilter: React.FC<FeedbacksFilterProps> = ({
  dateFilter,
  typeAndStatusFilter,
  updateDate,
  updateFeedbackType,
  updateFeedbackStatus,
  feedbackTypeList
}) => {
  const { translate } = usePortalTranslation();
  const [fromDate, setFromDate] = useState<Dayjs>(dateFilter.fromDate);
  const [toDate, setToDate] = useState<Dayjs>(dateFilter.toDate);
  const [feedbackType, setFeedbackType] = useState<string>(
    typeAndStatusFilter.feedbackType
  );
  const [feedbackStatus, setFeedbackStatus] = useState<string>(
    typeAndStatusFilter.feedbackStatus
  );
  const [dateFilterInputValidation, setDateFilterInputValidation] =
    useState<string>("");
  const feedbackStatusList = ["All",...getFeedbackStatusList()];
  const feedbackTypesList = ["All", ...feedbackTypeList];

  const validateDateRange = () => {
    if (fromDate && toDate) {
      const isRangeExceeded = toDate.diff(fromDate, "day") > 31;
      const isOrderInvalid = fromDate.isAfter(toDate);

      if (isRangeExceeded) {
        setDateFilterInputValidation(translate(TranslationEnum.common_portal,"The date range cannot exceed 31 days."));
        return true; // Invalid range
      }

      if (isOrderInvalid) {
        setDateFilterInputValidation(
          translate(TranslationEnum.common_portal, "From date must be before or equal to the To date.")
        );
        return true; // Invalid order
      }
    }

    setDateFilterInputValidation(""); // Reset validation message
    return false; // Valid range
  };

  const handleFilterApply = () => {
    // Validate the date range before applying the filter
    if (!validateDateRange()) {
      updateDate(fromDate, "from");
      updateDate(toDate, "to");
      updateFeedbackType(feedbackType || "All");
      updateFeedbackStatus(feedbackStatus || "All");
    }
  };
  useEffect(() => {
    validateDateRange();
  }, [fromDate, toDate]);
  return (
    <div className="feedbacksFilter-wrapper">
      <div className="feedbacksFilter-forms-container">
        <div className="feedbacksFilter-forms-datePickers-wrapper">
          <div className="feedbacksFilter-forms-datePickers">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={translate(TranslationEnum.common_portal, "From Date")}
                inputFormat="DD-MM-YYYY"
                value={fromDate}
                maxDate={dayjs()}
                onChange={(value) => {
                  if (value) {
                    setFromDate(value);
                  }
                }}
                renderInput={(props) => <TextField {...props} size="small" />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={translate(TranslationEnum.common_portal, "To Date")}
                inputFormat="DD-MM-YYYY"
                value={toDate}
                maxDate={dayjs()}
                onChange={(value) => {
                  if (value) {
                    setToDate(value);
                  }
                }}
                renderInput={(props) => <TextField {...props} size="small" />}
              />
            </LocalizationProvider>
          </div>

          <div className="feedbacksFilter-forms-datePickers-validation-error">
            {dateFilterInputValidation} {/* Show validation error here */}
          </div>
        </div>

        <Autocomplete
          sx={{ width: "100%" }}
          value={feedbackType === "" ? null : feedbackType}
          onChange={(event, newValue) => {
            setFeedbackType(newValue || "");
          }}
          options={feedbackTypesList}
          renderInput={(params) => (
            <TextField {...params} label={translate(TranslationEnum.manage_feedbacks,"Feedback Type")} />
          )}
        />

        <Autocomplete
          sx={{ width: "100%" }}
          value={feedbackStatus === "" ? null : feedbackStatus}
          onChange={(event, newValue) => {
            setFeedbackStatus(newValue || "");
          }}
          options={feedbackStatusList}
          renderInput={(params) => <TextField {...params} label={translate(TranslationEnum.manage_feedbacks,"Status")} />}
        />
      </div>

      <div
        className={`feedbacksFilter-apply-button ${
          dateFilterInputValidation
            ? "manageFeedback-disabled-button"
            : "manageFeedbacks-active-button"
        }`}
        onClick={()=>{if(!dateFilterInputValidation) handleFilterApply()}}
      >
        {translate(TranslationEnum.common_portal,"Apply")}
      </div>
    </div>
  );
};

export default FeedbacksFilter;
